import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, noop as _$no, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { makeStyles } from './styles';
import { getRestProps } from '../utils';
import { Ellipsis } from '../ellipsis';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    span = _this$get.span,
    label = _this$get.label,
    content = _this$get.content,
    append = _this$get.append;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-description-item"] = true, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), [_$ce(2, 'div', (_$blocks['label'] = function ($super) {
    return label ? label : undefined;
  }, __$blocks['label'] = function ($super, data) {
    var block = $blocks['label'];
    var callBlock = function callBlock() {
      return _$blocks['label'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['label'](_$no)), 0, _$cn(k + "-description-item-label")), _$ce(2, 'div', [_$cc(Ellipsis, {
    'children': content || children
  }), $blocks.append || append ? _$ce(2, 'div', (_$blocks['append'] = function ($super) {
    return append ? append : undefined;
  }, __$blocks['append'] = function ($super, data) {
    var block = $blocks['append'];
    var callBlock = function callBlock() {
      return _$blocks['append'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['append'](_$no)), 0, _$cn(k + "-description-option")) : undefined], 0, _$cn(k + "-description-centent"))]);
}
;